import React from "react";
import { Button } from "../ui/button";
import { Trash2 } from "lucide-react";

export const WalkthroughItemCard = ({ item, index, onRemove, tag }) => (
  <div className={`flex gap-3 rounded-xl border p-3 ${item.removed ? "bg-slate-50 border-slate-200 opacity-70" : "bg-white border-slate-200"}`}
    data-testid={`walkthrough-item-${item.defect_id || item.id}`}>
    <div className="w-7 h-7 shrink-0 rounded-full bg-amber-100 text-amber-800 text-sm font-bold flex items-center justify-center">{index + 1}</div>
    <div className="flex-1 min-w-0">
      <div className="flex flex-wrap items-center gap-2">
        <p className={`font-semibold text-slate-900 ${item.removed ? "line-through" : ""}`}>{item.area} — {item.element}</p>
        {item.removed && (
          <span className="text-[11px] font-bold uppercase rounded-full bg-red-100 text-red-700 px-2 py-0.5" data-testid="walkthrough-item-removed-badge">
            Removed after walkthrough
          </span>
        )}
        {tag && <span className="text-[11px] font-bold uppercase rounded-full bg-sky-100 text-sky-800 px-2 py-0.5">{tag}</span>}
      </div>
      <p className="text-sm text-slate-700">{item.issue}{item.details ? ` — ${item.details}` : ""}</p>
      {item.images?.length > 0 && (
        <div className="flex gap-2 mt-2">
          {item.images.map((src, i) => <img key={i} src={src} alt="" className="w-16 h-16 rounded-md object-cover border border-slate-200" />)}
        </div>
      )}
    </div>
    {onRemove && (
      <Button size="icon" variant="ghost" onClick={() => onRemove(item)} aria-label="Remove item" className="text-red-600 shrink-0"
        data-testid={`walkthrough-item-remove-${item.id}`}>
        <Trash2 className="w-4 h-4" />
      </Button>
    )}
  </div>
);
